import { render, staticRenderFns } from "./searchList.vue?vue&type=template&id=b1266dd4&scoped=true"
import script from "./searchList.vue?vue&type=script&lang=js"
export * from "./searchList.vue?vue&type=script&lang=js"
import style0 from "./searchList.vue?vue&type=style&index=0&id=b1266dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1266dd4",
  null
  
)

export default component.exports